import { render, staticRenderFns } from "./TextAreaWidget.vue?vue&type=template&id=3e247591&"
import script from "./TextAreaWidget.vue?vue&type=script&lang=ts&"
export * from "./TextAreaWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports